import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dt from '../../../../shared/theme';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: fit-content;
  padding: 0 12px;
  color: ${props => dt(props).theme.bodyColor};
  background-color: ${props => dt(props).theme.bodyBackgroundColor};
  border: 1px solid #BBCBD8;
  box-sizing: border-box;
  border-radius: 4px;
  font: ${props => dt(props).theme.fontWeightBold} 14px/12px ${props => dt(props).theme.fontFamilyBody};
  text-transform: none;
`;

export default function PerformanceFeeCharged({ isPerformanceFeeCharged }) {
  const text = isPerformanceFeeCharged ? 'Performance Fee Applies ' : 'No Performance Fee';

  return (
    <Container>{text}</Container>
  );
}

PerformanceFeeCharged.propTypes = {
  isPerformanceFeeCharged: PropTypes.bool.isRequired,
};
